module.exports = __webpack_public_path__ + "static/media/courrier_accompagnement_proposition_GPI_GO_viasante.e3bfcbc0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/common/form/courrier_accompagnement_proposition_GPI_GO_viasante.pdf
// module id = 314
// module chunks = 40